import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../lib/api";
import { PanelSection } from "../components/PanelSection";
import CinemaCarousel from "../components/CinemaCarousel";
import { TeamGrid } from "../components/TeamGrid";
import { WHATSAPP_HREF, waLink } from "../lib/team";

const withCta = (s) => ({
  ...s,
  cta_label: s.cta_label || "Chiedi un preventivo",
  cta_href: s.cta_href || waLink(`Ciao, vorrei informazioni sul servizio: ${s.kicker || s.title}`),
});

export default function Servizi() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services")
      .then((r) => setServices(Array.isArray(r.data) ? r.data : []))
      .catch(() => setServices([]));
  }, []);

  return (
    <div style={{ background: "#F2EFE9" }} data-testid="servizi-page">
      <ServiziIntro services={services} />
      {services.map((s, i) => (
        <div id={`servizio-${i}`} key={s.id}>
          <PanelSection panel={withCta(s)} index={i} isFirst={false} testPrefix="servizio" />
        </div>
      ))}
      <CinemaCarousel overline="I nostri lavori" title="Guarda cosa giriamo." />
      <section className="px-6 sm:px-12 py-24 sm:py-32" data-testid="servizi-team">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-[11px] uppercase tracking-[0.3em] mb-6" style={{ color: "#8a8a8a" }}>Il team</div>
          <h2 className="text-4xl sm:text-6xl mb-14" style={{ color: "#111", fontWeight: 300, letterSpacing: "-0.02em" }}>
            Chi c'è dietro la camera.
          </h2>
          <TeamGrid />
          <Link to="/chi-siamo" className="inline-block mt-10 text-[14px] underline" style={{ color: "#111" }} data-testid="servizi-team-link">
            La nostra storia →
          </Link>
        </div>
      </section>
      <ServiziClosing />
    </div>
  );
}

function ServiziIntro({ services }) {
  return (
    <section className="px-6 sm:px-12 pt-36 pb-24" data-testid="servizi-intro">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-[1200px] mx-auto">
        <div className="text-[11px] uppercase tracking-[0.3em] mb-6" style={{ color: "#FF2800" }}>Cosa facciamo</div>
        <h1 className="text-5xl sm:text-7xl lg:text-8xl mb-8 max-w-[1000px]" style={{ color: "#111", fontWeight: 300, letterSpacing: "-0.03em", lineHeight: 1.02 }}>
          Non solo motori. Ogni tua idea.
        </h1>
        <p className="text-[17px] sm:text-[20px] max-w-[680px] mb-14" style={{ color: "#5a5a5a", lineHeight: 1.6 }}>
          Giriamo e montiamo video per ogni tua idea, e raccontiamo al meglio quello che vuoi comunicare. Con te, il nostro team scrive lo storytelling da seguire.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 border-t" style={{ borderColor: "rgba(0,0,0,0.12)" }}>
          {services.map((s, i) => (
            <a
              key={s.id}
              href={`#servizio-${i}`}
              onClick={(e) => { e.preventDefault(); document.getElementById(`servizio-${i}`)?.scrollIntoView({ behavior: "smooth" }); }}
              className="group py-6 pr-6 border-b flex items-baseline gap-4"
              style={{ borderColor: "rgba(0,0,0,0.12)" }}
              data-testid={`servizi-index-${i}`}
            >
              <span className="text-[11px]" style={{ color: "#FF2800", letterSpacing: "0.2em" }}>{String(i + 1).padStart(2, "0")}</span>
              <span className="text-[16px] transition-transform duration-300 group-hover:translate-x-1" style={{ color: "#111" }}>{s.kicker || s.title}</span>
            </a>
          ))}
        </div>
      </motion.div>
    </section>
  );
}

function ServiziClosing() {
  return (
    <section className="px-6 sm:px-12 py-24 sm:py-32 text-center" style={{ background: "#000" }} data-testid="servizi-closing">
      <div className="text-[11px] uppercase tracking-[0.3em] mb-6" style={{ color: "#FF2800" }}>Parliamone</div>
      <h2 className="text-4xl sm:text-6xl mb-6" style={{ color: "#FFF", fontWeight: 300, letterSpacing: "-0.02em" }}>
        Hai un progetto in mente?
      </h2>
      <p className="text-[16px] mb-10 max-w-[560px] mx-auto" style={{ color: "#8a8a8a", lineHeight: 1.6 }}>
        Scrivici su WhatsApp: due righe sul progetto e ti rispondiamo con idee e un preventivo.
      </p>
      <a
        href={WHATSAPP_HREF}
        target="_blank"
        rel="noreferrer"
        className="inline-block px-8 py-4 text-[14px] transition-opacity duration-300 hover:opacity-85"
        style={{ background: "#25D366", color: "#FFF", fontWeight: 500 }}
        data-testid="servizi-whatsapp"
      >
        Scrivici su WhatsApp
      </a>
    </section>
  );
}
